.container {
  margin: auto;
  min-height: 80vh;
  overflow: hidden;
  padding-top: 60px;
  scroll-behavior: smooth;
  width: 100%;
}

*::-webkit-scrollbar {
  width: 10px;
}

*::-webkit-scrollbar-thumb {
  background-clip: padding-box;
  background-color: var(--theme-blue);
  border: 2px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  min-height: 50px;
}

*::-webkit-scrollbar-track {
  background-color: rgb(0 0 0 / 0%);
}

* {
  -webkit-tap-highlight-color: rgb(0 0 0 / 0%);
}

::selection {
  background: rgb(0 0 0 / 30%);
}

a,
button {
  -webkit-tap-highlight-color: rgb(0 0 0 / 0%);
}
